import React from "react";
import "~/css/reception/ReceptionKeypadButton.css";

type ReceptionKeypadButtonSize = "small" | "medium" | "mediumLarge" | "large";
type ReceptionKeypadButtonVariant = "default" | "primary";

type Props = {
  ariaLabel: string;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  label?: string;
  onClick?: () => void;
  size?: ReceptionKeypadButtonSize;
  type?: "button" | "submit" | "reset";
  variant?: ReceptionKeypadButtonVariant;
};

const BUTTON_SIZE_MAP: Record<ReceptionKeypadButtonSize, number> = {
  small: 24,
  medium: 40,
  mediumLarge: 60,
  large: 80,
};

/**
 * 受付用のキーパッドボタン。
 * 中身は常に 24px 基準で描画し、インスタンス側で外枠サイズのみ切り替える。
 */
const ReceptionKeypadButton: React.FC<Props> = ({
  ariaLabel,
  children,
  className,
  disabled = false,
  label,
  onClick,
  size = "large",
  type = "button",
  variant = "default",
}) => {
  const resolvedClassName = [
    "reception-keypad-button",
    `reception-keypad-button--${variant}`,
    `reception-keypad-button--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      aria-label={ariaLabel}
      className={resolvedClassName}
      disabled={disabled}
      onClick={onClick}
      style={
        {
          "--reception-keypad-button-size": `${BUTTON_SIZE_MAP[size]}px`,
        } as React.CSSProperties
      }
    >
      <span className="reception-keypad-button__content">
        {label ? (
          <span
            className={
              variant === "primary"
                ? "reception-keypad-button__action"
                : "reception-keypad-button__label"
            }
          >
            {label}
          </span>
        ) : (
          children
        )}
      </span>
    </button>
  );
};

export default ReceptionKeypadButton;
